export default __webpack_public_path__ + "static/media/sunset.99d28354.png";